import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import '../index.less'
import RulesContent from './RulesContent'
import RulesDetail from './RulesDetail.vue'
import RulesViews from './RulesViews'
import CreatModal from './components/CreatModal.vue'
import { CodeRuleServiceProxy, CodeGeneratorServiceProxy } from '@/service-proxies/app-v2/code.service-proxies'

const cgsp = new CodeGeneratorServiceProxy()
const crsp = new CodeRuleServiceProxy()

@Component({
  components: {
    RulesContent,
    RulesDetail,
    RulesViews,
    CreatModal
  }
})
export default class CodingRulesDetail extends Vue {
  @Prop({ default: ""}) readonly menuKey: String
  @Prop({ default: ""}) readonly searchValue: String
  @Prop({ default: () => []}) readonly data: Array<any>
  @Prop({ default: false}) readonly loading: Boolean

  selectRowKey = "" // 选中行key
  detail = {}
  objCode = ""
  fieldList = []
  objectsList = []
  createdVisible = false

  @Watch("data", { immediate: true })
  handleget(){
    if(this.data && this.data.length){
      this.selectRowKey = this.data[0].id
      this.getDetail(this.data[0].id)
    } else{
      this.selectRowKey = ""
      this.detail = {}
      this.fieldList = []
    }
    this.objectsList = []
    this.getApplicationObjects()
  }
  
  getApplicationObjects(){
    cgsp.getAllApplicationObjects().then(res =>{
      this.objectsList = res
    })
  }

  rowClick(id){
    if(id !== this.selectRowKey){
      this.selectRowKey = id
      this.getDetail(id)
    }
  }

  getDetail(id){
    this.fieldList = []
    crsp.detail(id).then(res =>{
      this.detail = res
      this.objCode = res.applicationObjectCode
      this.fieldList = res.fieldList
    })
  }

  chageCode(value){
    this.objCode = value
    this.fieldList = []
  }

  onSearch(value){
    console.log(value)
    this.$emit('search',value)
  }

  back(){
    crsp.remove(this.selectRowKey).then(() =>{
      this.$message.warning(this.$t('page_place_on_file_success'))
      this.$emit('reload')
    })
  }

  handleSave(value){
    this.fieldList = []
    value.map((res,index) => res.sort = index + 1)
    this.fieldList = value
  }

  saveAll(value){
    if(this.fieldList.length === 0){
      this.$message.warning('请添加属性列表')
      return
    }
    value.fieldList = this.fieldList
    crsp.save(value).then(() =>{
      this.$message.success('保存成功')
      this.$emit('reload')
    })
  }

  reload(){
    this.createdVisible = false
    this.$emit('reload')
  }

  creat(){
    this.createdVisible = true
  }

  render(){
    return(
      <blank-view mainStyle={{ 'background': "transparent", 'box-shadow': "none"}}>
        <div slot={'action'} style="display:flex;justify-content: space-between; padding: 8px 8px 0 8px;">
          <div>
            <a-button v-acl="page_system_coding_rules_name_creat" type="primary" onClick={() => this.creat()} style="margin-right: 8px;">{this.$t('create')}</a-button>
            <a-popconfirm
              title={this.$t('page_place_is_not_on_file')}
              onConfirm={() => this.back()}
            >
              <a-button disabled={!this.selectRowKey} v-acl="page_system_coding_rules_name_remove" type="danger" style="margin-right: 8px;">{this.$t('page_place_on_file')}</a-button>
            </a-popconfirm>
          </div>
          <div>
            <a-input-search style="width: 200px" placeholder={this.$t('keyword')} enterButton={this.$t('search')} onSearch={value => this.onSearch(value)} />
          </div>
        </div>
        <div id="inner" style="height:100%">
        <a-row style="height:100%;padding: 0 8px 8px">
          <a-col span={24} id="rulesContent-table" style="height: 40%">
            <RulesContent loading={this.loading} dataSource={this.data} selectRowKey={this.selectRowKey} onRowClick={value => this.rowClick(value)}></RulesContent>
          </a-col>
          <a-col span={24} style="height: 60%;padding: 8px;background-color: #FAFAFA;border: 1px solid #e5e5e5">
            <a-row style="height:100%">
              <a-col span={16} id="rulesViews-table" style="height:100%;padding-right: 8px;border-right: 1px solid #e5e5e5">
                <RulesViews data={this.fieldList} code={this.objCode} onAddSave={value => this.handleSave(value)}></RulesViews>
              </a-col>
              <a-col span={8} style="height:100%;padding-left: 8px;overflow:auto">
                <rules-detail detail={this.detail} objectsList={this.objectsList} onSaveAll={value => this.saveAll(value)} onChange={value => this.chageCode(value)}></rules-detail>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
        </div>
        <creat-modal 
          visible={this.createdVisible}
          objectsList={this.objectsList}
          onCancel={() => this.createdVisible = false}
          onSave={() => this.reload()}
        ></creat-modal>
      </blank-view>
    )
  }
}
